import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export default function CsvHeaderCell({ title, width, onResize }) {
  const [isDragging, setIsDragging] = useState(false);
  const [indicatorOffset, setIndicatorOffset] = useState(0);
  const startXRef = useRef(0);
  const isResizing = useRef(false);
  const cellRef = useRef(null);
  const handleMouseMove = useCallback(e => {
    setIndicatorOffset(e.clientX - startXRef.current);
  }, []);
  const handleMouseUp = useCallback(
    e => {
      if (!isResizing.current) {
        return;
      }

      isResizing.current = false;
      setIsDragging(false);
      setIndicatorOffset(0);
      document.removeEventListener('mousemove', handleMouseMove);

      if (cellRef.current) {
        const rect = cellRef.current.getBoundingClientRect();

        onResize(title, e.clientX - rect.x);
      }
    },
    [handleMouseMove, onResize, title],
  );

  useEffect(() => {
    globalThis.window.addEventListener('mouseup', handleMouseUp);

    return () => {
      isResizing.current = false;
      document.removeEventListener('mousemove', handleMouseMove);
      globalThis.window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp]);

  const handleMouseDown = e => {
    e.preventDefault();
    startXRef.current = e.clientX;
    isResizing.current = true;
    setIsDragging(true);
    document.addEventListener('mousemove', handleMouseMove);
  };

  return (
    <div ref={cellRef} className="relative flex-shrink-0" style={{ width }}>
      <p className="font-bold text-center pt-2 pb-2 bg-green-100 border text-dark-night truncate">
        {title}
      </p>
      {isDragging && (
        <div
          className="w-1 bg-slate-400 h-screen absolute z-20"
          style={{ right: `${-1.5 - indicatorOffset}px` }}
        />
      )}
      <button
        type="button"
        onMouseDown={handleMouseDown}
        tabIndex={0}
        className="w-4 bg-transparent border-0 mr-0 p-0 h-64 absolute right-[-2px] mt-0 pt-0 top-[-2px] z-20 cursor-col-resize"
      />
    </div>
  );
}

CsvHeaderCell.propTypes = {
  title: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  onResize: PropTypes.func.isRequired,
};
